import { useLocation } from 'react-router-dom'

const useQuery = (): URLSearchParams => {
  const { search } = useLocation()
  if (search) return new URLSearchParams(search)
  else return new URLSearchParams()
}

export default useQuery
